import CommonResources from "./CommonResources";

export default {
  ...CommonResources,
  title: "<b>Zarejestruj się</b> i korzystaj z goodie cashback",
  codeDescription: "Kod zaproszenia: ",
  formTitle: "Zarejestruj się",
  formTitleModal: "<b>Zarejestruj się</b> w goodie",
  formButton: "Rejestruję się przez {ProviderName}",
  socialButtonsTitle: "lub zarejestruj się tak jak lubisz",
  changeScreenButtonText: "Masz już konto?",
  changeScreenButtonLink: "Zaloguj się",
};
